import { Observable } from 'rxjs/Observable';
import { Component, ElementRef, Injector, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  CellDoubleClickedEvent,
  FilterChangedEvent,
  GridApi,
  GridOptions,
  GridReadyEvent,
  RowNode,
  SortChangedEvent
} from 'ag-grid';
import { constant } from 'app/app.constants';
import { AgGridSortFilterUtils } from 'app/core/ag-grid-utils/ag-grid-sort-filter-utils';
import {
  AgButtonsEnum,
  DepositAction,
  DepositsStatusEnum,
  ElectronicGridEnum,
  TabsElectronicEnum
} from 'app/core/enums/tabs-deposits.enum';
import { CustomDate } from 'app/core/helpers/format-date-helper';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { ToastrAlertHelper } from 'app/core/helpers/toastr-alert-helper-service';
import { ConciliationService } from 'app/core/services/conciliation.service';
import { UploadsService } from 'app/pages/A2-utils/uploads.service';
import { T2LoadingService } from 'app/trip2-theme/components/t2-loading/t2-loading.service';
import { Subscription } from 'rxjs/Subscription';
import { T2CardComponent } from 'app/trip2-theme/components/t2-card/t2-card.component';
import { _currencyFormat } from 'app/utils/trip2-query-builder/utils/helpers';
import { BtnCellRendererI } from 'app/core/interfaces/Btn-cell-renderer.interface';
import { BtnCellRendererComponent } from 'app/pages/A2-utils/grid-components/btn-cell-renderer/btn-cell-renderer.component';
import { ParentModule } from 'app/pages/A2-utils/ParentClass/parent-module';

@Component({
  selector: 'app-electronic',
  templateUrl: './electronic.component.html',
  styleUrls: ['./electronic.component.scss']
})
export class ElectronicComponent extends ParentModule implements OnInit, OnDestroy {
  @ViewChild('formAdd') private formAdd: T2CardComponent;
  @ViewChild('denialReasonsModal') private denialReasonsModal: T2CardComponent;
  @ViewChild('file') file: ElementRef;
  subscriptions: Subscription[] = [];
  formImportElectronic: FormGroup;
  upperGridOpt: GridOptions;
  tabsElectronic = constant.DEPOSITS_POSTING.TABS_ELECTRONIC;
  activatedTab = TabsElectronicEnum.Claims;
  headerDataSelected = {};
  totalAmountSelected = 0;
  totalBilledDetails = 0;
  totaPaidDetails = 0;
  totalBilledDetail= 0;
  totalAllowedDetail= 0;
  totalDeductDetail= 0;
  totalCoinsDetail= 0;
  totalPaidDetail= 0;
  totalRowsClaimsGrid = 0;
  totalRows = 0;
  totalRowsLowerGrid = 0;
  selectedRowIndex = null;
  filesnames: any;
  selectedProceduteClaimDetail: string;
  selectedIcnClaimDetail: string;
  selectedLowerGridOptRows = 0;
  electronicId = null;

  totalAllowedAmount: string;
  totalBilledAmount: string;
  totalCheckeftAmount: string;
  totalCoinsuranceAmount: string;
  totalDeductibleAmount: string;
  totalInterestAmount: string;
  totalPaidToProvider: string;
  totalReasonAdjustmentAmount: string;
  electronicProviderAdjustment: any;
  remitSummary = false;
  checkId: number;
  checkDetail: any;
  lastCheckDetail: any;
  firstDetail: any;
  isDeleteElectronic = false;

  disableClearFilterUpperGridOpt = true;
  disableClearSortUpperGridOpt = true;
  disableClearFilterLowerGridOpt = true;
  disableClearSortLowerGridOpt = true;
  disableClearFilterClaimDetailGrid = true;
  disableClearSortClaimDetailGrid = true;

  readonly agGridButtonActionList = {
    RemoveFilter: AgButtonsEnum.RemoveFilter,
    RemoveSort: AgButtonsEnum.RemoveSort
  };

  readonly agGridElectronic = {
    UpperGrid: ElectronicGridEnum.UpperGridOpt,
    LowerGrid: ElectronicGridEnum.LowerGridOpt,
    ClaimDetailsGrid: ElectronicGridEnum.ClaimDetailGrid
  };

  constructor(
    private fb: FormBuilder,
    private sweetAlertHelper: SweetAlertHelper,
    private toastrAlertHelper: ToastrAlertHelper,
    private t2LoadingService: T2LoadingService,
    private uploadsService: UploadsService,
    protected objServ: ConciliationService,
    protected Inject: Injector,
  ) {
    super('app-deposits', Inject);
    this.gridBuilder();
  }

  ngOnInit(): void {
    this.createForm();
    this.getDepositByCurrentMonth();
    this.initSubscription();
  }

  initSubscription() {
    this.subscriptions.push(
      this.actionsList$.subscribe((response) => {
        if (response && response.length ) {
          this.isDeleteElectronic = response.includes('DeleteElectronic');
          this.upperGridOpt.columnApi.setColumnVisible('action', this.isDeleteElectronic);
        }
      }),
      this.objServ.behaviorSubjDepositObs$.subscribe({
        next: (resp) => {
          if (
            resp &&
            resp.data &&
            resp.action &&
            (resp.action ===
              DepositAction.MonthPickerSetterValueChangesLockBoxResp ||
              resp.action ===
                DepositAction.MonthPickerSetterValueChangesPostedResp ||
              resp.action ===
                DepositAction.MonthPickerSetterValueChangesConciliationResp ||
              resp.action ===
                DepositAction.MonthPickerSetterValueChangesDeposit)
          ) {
            this.electronicMonthPostedCtrl.patchValue(resp.data);
          }
        },
        error: (er) => {
          this.sweetAlertHelper.captureException(er);
        },
      }),
      this.objServ.behaviorSubjDepositObs$.subscribe({
        next: (resp) => {
          if (
            resp &&
            resp.data &&
            resp.action &&
            resp.action === DepositAction.SearchElectronic
          ) {
            this.loadGrid();
            this.electronicMonthPostedCtrl.valueChanges.subscribe({
              next: (res) => {
                if (res) {
                  this.objServ.behaviorSubjDeposit.next({
                    action:
                      DepositAction.MonthPickerSetterValueChangesElectronicResp,
                    data: res,
                  });
                }
              },
              error: (er) => {
                this.sweetAlertHelper.captureException(er);
              },
            });
          }
        },
        error: (er) => {
          this.sweetAlertHelper.captureException(er);
        },
      })
    );
  }

  clearControl(controlName: string): void {
    this.formImportElectronic.get(controlName).patchValue('');
  }

  onAdd(): void {
    this.formAdd.open();
  }

  cancel(): void {
    this.formAdd.close();
  }

  getDepositByCurrentMonth(): void {
    this.formImportElectronic
      .get('checkdate')
      .patchValue(CustomDate.formatJsV2(CustomDate.getDate()), {
        emitEvent: false,
      });
  }

  gridBuilder(): void {
    this.upperGridOpt = <GridOptions> {
      enableColResize: true,
      enableSorting: true,
      enableFilter: true,
      frameworkComponents: {
        buttonRenderer: BtnCellRendererComponent
      },
      columnDefs: [
        {
          headerName: 'Payer Name',
          field: 'electroniclist.payername',
          width: 250
        },
        {
          headerName: 'Payee Name',
          field: 'electroniclist.payeename',
          width: 250
        },
        {
          headerName: 'Payee ID',
          field: 'electroniclist.payeeid',
          width: 90,
          cellStyle: { 'text-align': 'end' }
        },
        {
          headerName: 'Check Date',
          field: 'electroniclist.checkdate',
          width: 100,
          valueGetter: (params) => {
            if (params && params.data.electroniclist.checkdate) {
              return CustomDate.formatJs(params.data.electroniclist.checkdate);
            }
          },
          cellStyle: { 'text-align': 'center' }
        },
        {
          headerName: 'Claim',
          field: 'claimscount',
          width: 100,
          cellStyle: { 'text-align': 'end' }
        },
        {
          headerName: 'Check/EFT Amt.',
          field: 'electroniclist.checkeft',
          cellStyle: { 'text-align': 'end' },
          width: 120,
          cellRenderer: (params) => {
            return _currencyFormat(params.data.electroniclist.checkeft);
          },
          filterParams: AgGridSortFilterUtils.sortFilterColumn
        },
        {
          headerName: 'Check/EFT Number',
          field: 'electroniclist.checkeftnumber',
          width: 120
        },
        {
          headerName: 'Deposit Id',
          field: 'electroniclist.depositid',
          width: 120
        },
        {
          headerName: 'Posted Ids',
          field: 'electroniclist.postedid',
          width: 120
        },
        {
          headerName: 'Status',
          field: 'electroniclist.statusid',
          width: 110,
          cellStyle: params => {
            const cellStyleObj = { 'text-align': 'start', color: 'black', 'font-weight' : 'normal' };
            if (params && params.data.electroniclist.statusid) {
              switch (params.data.electroniclist.statusid) {
                case DepositsStatusEnum.Pending:
                case DepositsStatusEnum.Incomplete:
                  cellStyleObj.color = 'red';
                  cellStyleObj['font-weight'] = 'bold';
                  break;
                case DepositsStatusEnum.Completed:
                  cellStyleObj.color = 'green';
                  cellStyleObj['font-weight'] = 'bold';
                  break;
                default:
                  break;
              }
            }
            return cellStyleObj;
          },
          cellRenderer: (params) => {
            if (params && params.data && params.data.electroniclist && params.data.electroniclist.statusid) {
              return this.getStatusText(params.data.electroniclist.statusid);
            } else {
              return 'error mapping statusid';
            }
          }
        },
        {
          headerName: 'Actions',
          field: '',
          colId: 'action',
          cellRenderer: 'buttonRenderer',
          cellStyle: {
            color: 'red',
            'font-size': '15px',
            'text-align': 'center'
          },
          width: 40,
          hide: this.isDeleteElectronic,
          cellRendererParams: (params: any) => {
            if (params && params.data.electroniclist.electronicid && this.isDeleteElectronic) {
              const OBJ_RETURN: BtnCellRendererI = {
                onClick: () => this.deleteElectronic(params.data.electroniclist.electronicid),
                classFontAwesome: 'fa-trash',
                bgColor: '#fff',
                color: '#ee0000',
                title: `Delete Electronic #${params.data.electronicid}`,
                border: '1px solid #ddd',
              };

              return OBJ_RETURN;
            } else {
              return {
                onClick: null,
                classFontAwesome: '',
                title: ``,
                showBtn: false,
              };
            }
          }
        },
      ],
      rowClassRules: {
        'row-default-deposit-grid': (params: { data: { electroniclist: { electronicid: any; }; }}) => {
          return params.data.electroniclist.electronicid !== null;
        },
        'row-selected-deposit': (params: { data: { electroniclist: { electronicid: any; }; }}) => {
          return params && params.data && params.data.electroniclist.electronicid === this.selectedRowIndex;
        }
      },
      onGridReady: (event: GridReadyEvent) => {
        if (event && this.upperGridOpt.api) {
          this.selectedRowIndex = null;
          this.upperGridOpt.api.setRowData([]);
          this.upperGridOpt.api.sizeColumnsToFit();
        }
      },
      onCellDoubleClicked: (params: CellDoubleClickedEvent) => {
        if (params && params.data && params.data.electroniclist.electronicid) {
          this.selectedRowIndex = params.data.electroniclist.electronicid;
          this.upperGridOpt.api.redrawRows();
          this.getElectronicDetail(params.data.electroniclist.electronicid);
          this.objServ.setClaimsCount(params.data.claimscount);
          this.checkId = params.data.electroniclist.payeeid;
          this.onChangeTabs(this.tabsElectronic.Claim);
        }
      },
      onFilterChanged: ({ api }: FilterChangedEvent) => this.onFilterChangedGrid(api, ElectronicGridEnum.UpperGridOpt),
      onSortChanged: ({ api }: SortChangedEvent) => this.updateClearAndFilterBtn(api, ElectronicGridEnum.UpperGridOpt),
      getRowNodeId: (data) => data.id
    };
  }

  clearFilterAndSort(AgButtonAction: AgButtonsEnum, gridKey: ElectronicGridEnum) {
    const gridApiByElectronicGridEnum = {
      [ElectronicGridEnum.UpperGridOpt]: this.upperGridOpt.api
    };

    const gridApi: GridApi = gridApiByElectronicGridEnum[gridKey];

    switch (AgButtonAction) {
      case AgButtonsEnum.RemoveFilter:
        gridApi.setFilterModel(null);
        break;
      case AgButtonsEnum.RemoveSort:
        gridApi.setSortModel(null);
        break;
    }

    this.updateClearAndFilterBtn(gridApi, gridKey);
  }

  updateClearAndFilterBtn(gridApi: GridApi, gridKey: ElectronicGridEnum) {
    const disableClearFilterBtn: boolean = !Object.keys(gridApi.getFilterModel()).length;
    const disableClearSortBtn: boolean = !gridApi.getSortModel().length;

    switch (gridKey) {
      case ElectronicGridEnum.UpperGridOpt:
        this.disableClearFilterUpperGridOpt = disableClearFilterBtn;
        this.disableClearSortUpperGridOpt = disableClearSortBtn;
        break;
      case ElectronicGridEnum.ClaimDetailGrid:
        this.disableClearFilterClaimDetailGrid = disableClearFilterBtn;
        this.disableClearSortClaimDetailGrid = disableClearSortBtn;
        break;
      case ElectronicGridEnum.LowerGridOpt:
        this.disableClearFilterLowerGridOpt = disableClearFilterBtn;
        this.disableClearSortLowerGridOpt = disableClearSortBtn;
        break;
    }
  }

  onFilterChangedGrid(gridApi: GridApi, gridKey: ElectronicGridEnum): void {
    this.updateClearAndFilterBtn(gridApi, gridKey);

    const onFilterChangedInUpperGridOpt = () => {
      const rows: RowNode[] = gridApi.getRenderedNodes();

      if (!rows.length) {
        this.totalAmountSelected = 0;
        return;
      }

      this.totalAmountSelected = this.calculateTotalAmount(
        rows.map(({ data }) => data.electroniclist),
        'checkeft'
      );
    };

    const onFilterChangedInClaimDetailGrid = () => {
      const rows: RowNode[] = gridApi.getRenderedNodes();

      if (!rows.length) {
        this.totalBilledDetail = 0;
        this.totalAllowedDetail = 0;
        this.totalDeductDetail = 0;
        this.totalCoinsDetail = 0;
        this.totalPaidDetail = 0;
        return;
      }

      const details = rows.map(({ data }) => data);

      this.totalBilledDetail = this.calculateTotalAmount(
        details,
        'billedamount'
      );
      this.totalAllowedDetail = this.calculateTotalAmount(
        details,
        'totalallowedamount'
      );
      this.totalDeductDetail = this.calculateTotalAmount(
        details,
        'deductibleamount'
      );
      this.totalCoinsDetail = this.calculateTotalAmount(
        details,
        'coinsuranceamount'
      );
      this.totalPaidDetail = this.calculateTotalAmount(details, 'paidamount');
    };

    const onFilterChangedLowerGridOpt = (): void => {
      gridApi.deselectAll();
      const rows: RowNode[] = gridApi.getRenderedNodes();

      if (!rows.length) {
        this.totalBilledDetails = 0;
        this.totaPaidDetails = 0;
        return;
      }

      const data = rows.map(row => row.data);
      this.totalBilledDetails = this.calculateTotalAmount(data, 'billedamount');
      this.totaPaidDetails = this.calculateTotalAmount(data, 'paidamount');
    };

    switch (gridKey) {
      case ElectronicGridEnum.UpperGridOpt:
        onFilterChangedInUpperGridOpt();
        break;
      case ElectronicGridEnum.ClaimDetailGrid:
        onFilterChangedInClaimDetailGrid();
        break;
      case ElectronicGridEnum.LowerGridOpt:
        onFilterChangedLowerGridOpt();
        break;
    }
  }

  onSelectionChangedGrid(gridApi: GridApi, gridKey: ElectronicGridEnum): void {
    const onLowerGridOptSelectionChanged = () => {
      const selectedRows = gridApi.getSelectedRows();

      if (!selectedRows.length) {
        this.selectedLowerGridOptRows = 0;
        return;
      }

      this.selectedLowerGridOptRows = selectedRows.length;
    };

    switch (gridKey) {
      case ElectronicGridEnum.UpperGridOpt:
        break;
      case ElectronicGridEnum.ClaimDetailGrid:
        break;
      case ElectronicGridEnum.LowerGridOpt:
        onLowerGridOptSelectionChanged();
        break;
    }
  }


  selectedFiles(event: any): void {
    if (
      event &&
      event.target &&
      event.target.files &&
      event.target.files.length
    ) {
      let texto = '';
      for (const name of event.target.files) {
        texto += name.name + ', ';
      }
      this.filesnames = texto;
      this.formImportElectronic.patchValue({
        uploadfiles: event.target.files,
      });
    }
  }

  createForm(): void {
    this.formImportElectronic = this.fb.group({
      uploadfiles: ['', Validators.required],
      checkdate: ['', Validators.required]
    });
  }

  save(): void {
    const formData = Object.assign({}, this.formImportElectronic.getRawValue());
    formData.filesnames = this.filesnames;
    if (this.formImportElectronic.valid) {
      this.sweetAlertHelper
        .createCustomAlert({
          title: 'Process File',
          text: 'Are you sure you want to process these remittance files?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Yes, import it!',
          cancelButtonText: 'No, cancel!',
        })
        .then((result) => {
          const url = `${constant.URL_ELECTRONICT}/import`;

          if (result.value) {
            this.toastrAlertHelper.info('Importing file');
            this.uploadAnsi(url, formData);
          }
        });
    } else {
      this.sweetAlertHelper
        .createCustomAlert({
          title: 'Error',
          text: 'Please fill all required fields',
          type: 'error',
        })
        .then(() => {
          // this.formImportPosting.touched;
        });
    }
  }

  uploadAnsi(url: string, formData: any): void {
    this.t2LoadingService.show();
    this.subscriptions.push(
      this.uploadsService
        .makeFileRequest(url, [{ nameParam: 'dataBodyEra', data: null }], formData.uploadfiles)
        .finally(() => {
          this.cancel();
          this.loadGrid();
        })
        .subscribe(
          (resp: any) => {
            if (resp && resp.length) {
              this.t2LoadingService.hiden();
              let messageUpdate = '';

              resp.forEach((file: any) => {
                if (file) {
                  messageUpdate += `
                    <div style="border-bottom: 1px solid rgb(205, 205, 205);" >
                      File ${file.filename}
                      ${file.count > 0 ? 'was processed successfully!' :
                                                  '<span style="color: red;">Check is already processed.</span>'}.
                      <br /> <span style="font-weight: bold;">(Inserted Rows: ${file.count})</span> <br />`;

                      if (file.electroniclist.length) {
                        messageUpdate += `<br />
                        <div>Payer list</div>
                        <div class="scrollbar scrollbar-small" style="margin-bottom: 1px;">
                          <table style="width: 100%;">
                            <thead>
                              <tr>
                                  <th>#</th>
                                  <th>Payer Name</th>
                                  <th>Check Date</th>
                                  <th>Rows</th>
                              </tr>
                            </thead>
                            <tbody>`;
                            file.electroniclist.forEach((row: any, index: number) => {
                                messageUpdate += `
                                <tr>
                                  <td>${index + 1}</td>
                                  <td>${row.payername}</td>
                                  <td>${row.date ? CustomDate.formatJs(row.date) :  ''}</td>
                                  <td>${file.count}</td>
                                </tr>`;
                              });
                          messageUpdate += `
                            </tbody>
                          </table>
                        </div>`;

                      }
                  messageUpdate += `</div>`;
                }
              });

              this.sweetAlertHelper
              .createCustomAlert({
                title: 'Process File',
                html: `
                    <div>
                      <p>${messageUpdate}</p>
                    </div>
                `,
                type: 'warning',
              })
              .then(() => {
                this.getUpdateElectronicStatus()
                .subscribe({
                  next: (res) => {
                    if (res && res.message) {
                      this.toastrAlertHelper.success(res.message);
                      this.resetInputFile();
                    }
                  },
                  error: (er) => this.sweetAlertHelper.captureException(er)
                });
                // this.formImportPosting.reset();
              });
            }
          },
          (er) => {
            this.t2LoadingService.hiden();
            this.sweetAlertHelper.captureException(er);
          }
        )
    );
  }

  loadGrid(showInactive = false): void {
    const checkDate = this.formImportElectronic.get('checkdate').value;
    if (checkDate) {
      this.t2LoadingService.show();
      this.objServ.getElectronicList(showInactive, checkDate)
      .finally(() => this.t2LoadingService.hiden())
      .subscribe({
        next: (res) => {
          const gridApi: GridApi = this.upperGridOpt.api;
          const filterModel = gridApi.getFilterModel();
          const sortModel = gridApi.getSortModel();

          if (res && res.length) {
            this.totalRows = res.length;
            this.totalAmountSelected = this.calculateTotalAmount(
              res.map((item: { electroniclist: any; }) => item.electroniclist ? item.electroniclist : {}),
              'checkeft'
            );
            this.upperGridOpt.api.setRowData(res);
            this.upperGridOpt.api.sizeColumnsToFit();
            this.upperGridOpt.api.setFilterModel(filterModel);
            this.upperGridOpt.api.setSortModel(sortModel);
          } else {
            this.clearGrids();
          }
        }
      });
    }
  }

  getElectronicDetail(electronicId: number): void {
    if (electronicId) {
      this.electronicId = electronicId;
    }
  }

  calculateTotalAmount = (res: any[], key: string): number =>
  res.reduce((sum, item) => sum + (item[key] ? item[key] : 0), 0);

  refresh(): void {
    this.remitSummary = false;
    this.onChangeTabs(this.tabsElectronic.Claim);
    this.selectedRowIndex = null;
    this.loadGrid();
    this.objServ.resetElectronicId(true);
    this.resetCount();
    this.resetInputFile();
  }

  clearGrids(): void {
    this.upperGridOpt.api.setRowData([]);
  }

  toggleTab(tabNumber: number): boolean {
    return (this.activatedTab === tabNumber);
  }

  onChangeTabs(selectedTab: TabsElectronicEnum): void {
    switch (selectedTab) {
      case TabsElectronicEnum.Claims:
        this.totalBilledDetail = 0;
        this.totalAllowedDetail = 0;
        this.totalDeductDetail = 0;
        this.totalCoinsDetail = 0;
        this.totalPaidDetail = 0;
        this.totalRowsClaimsGrid = 0;
        this.activatedTab = selectedTab;
        break;
      case TabsElectronicEnum.ClaimsDetail:
        this.activatedTab = selectedTab;
        break;
      case TabsElectronicEnum.RemitSummary:
        this.activatedTab = selectedTab;
        break;
      default:
        break;
    }
  }

  getStatusText(params: any): string {
    switch (params) {
      case DepositsStatusEnum.Pending: return 'Pending';
      case DepositsStatusEnum.NotFound: return 'Not Found';
      case DepositsStatusEnum.OverPosted: return 'OverPosted';
      case DepositsStatusEnum.Completed: return 'Completed';
      case DepositsStatusEnum.Incomplete: return 'Incomplete';
      case DepositsStatusEnum.Misapplied: return 'Archived';
      case DepositsStatusEnum.NoEoB: return 'NoEoB';
      case DepositsStatusEnum.Trip2: return 'Trip2';
      case DepositsStatusEnum.Covalent: return 'Covalent';
      case DepositsStatusEnum.Posted: return 'Posted';
      default:
        return 'Unknown status';
    }
  }

  getUpdateElectronicStatus(): Observable<any> {
    return this.objServ.getUpdateElectronicStatus()
    .finally(() => this.t2LoadingService.hiden());
  }

  updateElectronicStatus(): void {
    this.t2LoadingService.show();
    this.resetInputFile();

    this.getUpdateElectronicStatus()
    .subscribe({
      next: (resp) => {
        if (resp && resp.message) {
          this.toastrAlertHelper.success(resp.message);
          this.refresh();
        }
      },
      error: (er) => this.sweetAlertHelper.captureException(er)
    });
  }

  resetInputFile(): void {
    this.filesnames = '';
    this.formImportElectronic.patchValue({
      uploadfiles: '',
    });
    this.file.nativeElement.value = '';
  }

  modalImportClose() {
    this.file.nativeElement.value = '';
    this.filesnames = null;
    this.formImportElectronic.patchValue({
      uploadfiles: null,
    });
  }

  get electronicMonthPostedCtrl(): AbstractControl {
    return this.formImportElectronic.get('checkdate');
  }

  resetCount() {
    this.totalAmountSelected = 0;
    this.totalBilledDetails = 0;
    this.totaPaidDetails = 0;
    this.totalBilledDetail = 0;
    this.totalAllowedDetail = 0;
    this.totalDeductDetail = 0;
    this.totalCoinsDetail = 0;
    this.totalPaidDetail = 0;
    this.totalRowsClaimsGrid = 0;
    this.totalRows = 0;
    this.totalRowsLowerGrid = 0;
  }

  deleteElectronic(electronicId: number) {
    this.sweetAlertHelper
      .createCustomAlert({
        title: 'Delete Electronic',
        text: 'Are you sure you want to delete this record?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Accept',
        cancelButtonText: 'Cancel',
      })
      .then((data) => {
        if (data.value) {
          this.subscriptions.push(
            this.objServ.deleteElectronicById(electronicId).subscribe({
              next: (value) => {
                if (value) {
                  const message = `
                <div class="scrollbar scrollbar-small" style="margin-bottom: 1px;">
                  <table style="width: 100%;">
                    <thead>
                      <tr>
                          <th>Payer Name</th>
                          <th>Check Date</th>
                      </tr>
                    </thead>
                    <tbody>
                        <tr>
                          <td>${value.payername}</td>
                          <td>${
                            value.checkdate
                              ? CustomDate.formatJs(value.checkdate)
                              : ''
                          }</td>
                        </tr>
                    </tbody>
                  </table>
                </div>`;
                this.sweetAlertHelper.createCustomAlert({
                  title: 'Record Delete',
                  html: message,
                  type: 'info',
                });
                };
                this.loadGrid();
              },
              error: (err) => {
                this.sweetAlertHelper.captureException(err);
              },
            })
          );
        }
      });
  }


  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  };
}



// WEBPACK FOOTER //
// ./src/app/pages/billing-general/deposits/electronic/electronic.component.ts